import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import styled from "styled-components";
import { AnimatePresence, motion } from "framer-motion";
import { PageNotFound, Loading } from "./pages";
import { Footer, Navbar } from "./components";
import { fetchProjects } from "./lib/sanity";
import MainPage from "./pages/MainPage";
import BackToTop from "./components/BackToTop";

function App() {
  const [themeMode, setThemeMode] = useState("light");
  const locationForAnim = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  document.title = "Shoumik Kumbhakar | Portfolio";

  const onPageLoad = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2200);
  };

  const fetchAllData = async () => {
    try {
      const projectsData = await fetchProjects();

      setProjects(projectsData);

      onPageLoad();
    } catch (error) {
      console.error("Error fetching data from Sanity:", error);
      onPageLoad(); // Still load the page even if there's an error
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  useEffect(() => {
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? setThemeMode("dark")
      : setThemeMode("light");
  }, []);

  if (!document.body.classList.contains(themeMode)) {
    document.body.className = themeMode;

    const root = document.documentElement;

    if (themeMode === "dark") {
      root.style.setProperty('--primary-background-rgb', '18, 18, 18');
      root.style.setProperty('--vibrant-rgb', '74, 91, 239');
      root.style.setProperty('--primary-text-rgb', '255, 255, 255');
    } else {
      root.style.setProperty('--primary-background-rgb', '248, 250, 252');
      root.style.setProperty('--vibrant-rgb', '74, 91, 239');
      root.style.setProperty('--primary-text-rgb', '0, 0, 0');
    }
  }

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading ? (
          <Loading key="loading" />
        ) : (
          <>
            <StyledApp
              id="App"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 0.8,
                ease: "easeInOut",
              }}
            >
              <Navbar themeMode={themeMode} setThemeMode={setThemeMode} />
              <AnimatePresence mode="wait" initial={false}>
                <Routes
                  location={locationForAnim}
                  key={locationForAnim.pathname}
                >
                  <Route path="/" element={<MainPage projects={projects} />} />
                  <Route path="*" element={<PageNotFound />} />
                </Routes>
              </AnimatePresence>
              <Footer />
            </StyledApp>
          </>
        )}
      </AnimatePresence>
    </>
  );
}

const StyledApp = styled(motion.div)`
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  --webkit-font-smoothing: antialiased;
`;

export default App;
